// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"2a004ee9","228":"2a004ee9","277":"2a004ee9","673":"2a004ee9","677":"2a004ee9","746":"2a004ee9","839":"6c52375c"}[chunkId] + ".chunk.css";
};